export * from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]';
export { default } from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]';
